import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, PedidosConsumidor } from './types';

export const INITIAL_STATE: PedidosConsumidor = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): PedidosConsumidor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_PEDIDOS_CONSUMIDOR_REQUEST: {
				break;
			}
			case Types.CONSULTA_PEDIDOS_CONSUMIDOR_SUCCESS: {
				draft.status = action.payload.status;
				const select = toSelect(
					action.payload.data.dominio,
					'descricao',
					'codigo',
				);
				draft.data = select;
				break;
			}
			case Types.CONSULTA_PEDIDOS_CONSUMIDOR_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTA_PEDIDOS_CONSUMIDOR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
